import { useGeocodingService } from '@ubilabs/google-maps-react-hooks';
import { useEffect } from 'react';

import { useLocatorStore } from '../../store/useLocatorStore';

export function useHandleGeocodeSearchInput() {
  const {
    currentLocation,
    setShouldGeoLocate,
    searchInput,
    setMapViewBounds,
    setRadius,
    setCurrentLocation,
    shouldGeoLocate,
  } = useLocatorStore((state) => state);

  const geocoder = useGeocodingService();

  useEffect(() => {
    if (!currentLocation && shouldGeoLocate && searchInput.length) {
      setShouldGeoLocate(false);
      geocoder?.geocode(
        { address: searchInput },
        (results: google.maps.GeocoderResult[] | null, status: google.maps.GeocoderStatus) => {
          if (status !== 'OK' || !results) {
            // eslint-disable-next-line no-console
            console.error(`Geocoding was not successful for the following reason: ${status}`);

            return;
          }

          const placeResult = results[0];
          const location = placeResult.geometry.location;

          if (!location) {
            return;
          }

          const viewport = placeResult.geometry.viewport;
          const placeType = placeResult.types;

          setCurrentLocation({ lat: location.lat(), lng: location.lng() });
          setMapViewBounds(viewport);

          // Country / region
          if (
            placeType?.includes('country') ||
            placeType?.includes('administrative_area_level_1') ||
            placeType?.includes('administrative_area_level_2')
          ) {
            setRadius(10);

            if (
              placeType?.includes('country') &&
              placeResult.address_components.some((component) => component.long_name === 'France')
            ) {
              // Set specific viewport for France
              const franceBounds = new window.google.maps.LatLngBounds(
                new window.google.maps.LatLng(42.0, -1.8), // Southwest corner (adjust as needed)
                new window.google.maps.LatLng(50.5, 8.2) // Northeast corner (adjust as needed)
              );

              setMapViewBounds(franceBounds);
            }

            if (
              placeType?.includes('country') &&
              placeResult.address_components.some((component) => component.long_name === 'Germany')
            ) {
              // Set specific viewport for Germany
              const germanyBounds = new window.google.maps.LatLngBounds(
                new window.google.maps.LatLng(47.27, 5.988), // Southwest corner
                new window.google.maps.LatLng(55.058, 15.041) // Northeast corner
              );

              setMapViewBounds(germanyBounds);
            }
          }
          // City / town
          else if (placeType?.includes('locality') || placeType?.includes('political')) {
            setRadius(10);
          }
          // Postcode or street
          else if (placeType?.includes('postal_code') || placeType?.includes('route')) {
            setRadius(10);
          }
        }
      );
    }
  }, [searchInput, currentLocation, shouldGeoLocate]);
}
